import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getCustomerCategories = createAsyncThunk(
  "customerCategory/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(`${API_URL.CUSTOMER_CATEGORY.SLUG}?${queryString}`);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Lookup variant — hits the permission-free /lookup endpoint. Used by dropdowns
// on screens of other modules; the management list keeps using getCustomerCategories.
export const getCustomerCategoriesLookup = createAsyncThunk(
  "customerCategory/getLookup",
  async (payload, { rejectWithValue }) => {
    try {
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();
      const { data } = await axios.get(`${API_URL.CUSTOMER_CATEGORY.LOOKUP}?${queryString}`);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createCustomerCategory = createAsyncThunk(
  "customerCategory/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${API_URL.CUSTOMER_CATEGORY.SLUG}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const editCustomerCategory = createAsyncThunk(
  "customerCategory/put",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(`${API_URL.CUSTOMER_CATEGORY.SLUG}`, payload);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteCustomerCategory = createAsyncThunk(
  "customerCategory/delete",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(`${API_URL.CUSTOMER_CATEGORY.SLUG}/${id}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

const customerCategorySlice = createSlice({
  name: "customerCategory",
  initialState: {
    customer_category_list: [],
    current_values: null,
    active_payload: null,
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCustomerCategories.fulfilled, (state, action) => {
      state.customer_category_list = action.payload.data.list;
    });
    builder.addCase(getCustomerCategoriesLookup.fulfilled, (state, action) => {
      state.customer_category_list = action.payload.data.list;
    });
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } = customerCategorySlice.actions;
export default customerCategorySlice.reducer;
